import stRanking from './stRanking';
import strategy from './strategy';
import taStrategy from './taStrategy';
import canslim from './canslim';

export default {
  stRanking,
  strategy,
  taStrategy,
  canslim,
};
